import { FC, useState } from "react";

import { CaptchaModelDocument } from "./Vote";

import classes from "./Vote.module.css";
import SectionHeader from "../Layout/SectionHeader";
import BottomSticky from "../UI/BottomSticky";
import Button from "../UI/Button";
import { getLang, i18n } from "../../i18n";

interface Props extends CaptchaModelDocument {
  voteCaptchaHandler: (color: string) => Promise<void>;
  balance: number;
}

const VoteCaptcha: FC<Props> = ({
  _id,
  select,
  option1,
  option2,
  voteCaptchaHandler,
  balance,
}) => {
  const lang = getLang();
  const t = i18n.voteCaptcha[lang];
  const [selected, setSelected] = useState("");
  const captchaClickHandler = () => {
    voteCaptchaHandler(selected.substring(1));
  };
  return (
    <>
      <SectionHeader
        label={t.title.replace("{select}", select)}
        back="/votes"
        black={true}
      />
      <section className={classes.voting}>
        <div className={classes.photos}>
          <div
            className={`${classes.photo} ${
              selected === option1 ? classes.selected : ""
            }`}
            onClick={() =>
              setSelected((prevState) => (prevState === option1 ? "" : option1))
            }
          >
            <div
              className={classes.captcha}
              style={{ backgroundColor: option1 }}
            ></div>
            {selected === option1 && (
              <div className={classes.checkbox}>
                <svg
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8.5" cy="8.5" r="8.5" fill="white" />
                  <circle cx="8.5" cy="8.5" r="6.5" fill="#4ECC5E" />
                  <path
                    d="M12 6L6.44898 11L4.49931 9.05102"
                    stroke="white"
                    strokeWidth="1.58333"
                  />
                </svg>
              </div>
            )}
          </div>
          <div
            className={`${classes.photo} ${
              selected === option2 ? classes.selected : ""
            }`}
            onClick={() =>
              setSelected((prevState) => (prevState === option2 ? "" : option2))
            }
          >
            <div
              className={classes.captcha}
              style={{ backgroundColor: option2 }}
            ></div>
            {selected === option2 && (
              <div className={classes.checkbox}>
                <svg
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8.5" cy="8.5" r="8.5" fill="white" />
                  <circle cx="8.5" cy="8.5" r="6.5" fill="#4ECC5E" />
                  <path
                    d="M12 6L6.44898 11L4.49931 9.05102"
                    stroke="white"
                    strokeWidth="1.58333"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
      </section>
      <div className={classes.balance}>
        <span>{t.balance}: </span> {balance.toFixed(2)} 🌕
      </div>
      <div
        className={`${classes.sticky} ${
          selected !== "" ? classes.visible : ""
        }`}
      >
        <BottomSticky>
          <div className="container">
            <Button
              label={t.voteButton}
              onClick={() => captchaClickHandler()}
            />
          </div>
        </BottomSticky>
      </div>
    </>
  );
};

export default VoteCaptcha;
